import { TheatreBasketPackMaterial } from './TheatreBasketPackMaterial';
import { TheatreBasketPackService } from './TheatreBasketPackService';

export class TheatreBasketPack {
  id: number;
  barcode: string;
  name: string;
  hasUnavailableItems: boolean;
  materials: TheatreBasketPackMaterial[];
  services: TheatreBasketPackService[];
  packBasketId: string;
  totalMaterials: number;
  isNewPack: boolean;
}
